import { Route, Router } from "@solidjs/router";
import { lazy, type JSX } from "solid-js";
import { ToastContainer } from "@/ui/soluid/index.ts";
import { AppProvider } from "@/ui/shared/AppContext.tsx";
import { AppShell } from "@/ui/shared/AppShell.tsx";

const Home = lazy(() => import("@/routes/Home.tsx"));
const Edit = lazy(() => import("@/routes/Edit.tsx"));
const Settings = lazy(() => import("@/routes/Settings.tsx"));

export function App(): JSX.Element {
  return (
    <AppProvider>
      <Router root={(props) => <AppShell>{props.children}</AppShell>}>
        <Route path="/" component={Home} />
        <Route path="/edit/:projectId" component={Edit} />
        <Route path="/settings" component={Settings} />
        <Route path="*" component={Home} />
      </Router>
      <ToastContainer position="bottom-center" dismissLabel="閉じる" />
    </AppProvider>
  );
}
